module.exports = require('./lib/no-important.js');



//////////////////
// WEBPACK FOOTER
// ./~/aphrodite/no-important.js
// module id = 20
// module chunks = 1 2 3